import { FormCheckboxField, FormTextField } from '@mfw/forms';
import { useIntl } from '@mfw/components';
import Box from '@mui/material/Box';

import { AddressController } from './FormAddressContext';
import { FormCountry } from './FormCountry';
import messages from './messages';

export interface FormAddressProps {
  optional?: {
    country?: boolean;
    street?: boolean;
    city?: boolean;
    zip?: boolean;
  };
  'data-testid'?: string;
  className?: string;
  readOnly?: boolean;
  name: string;
}

export const FormAddress = ({
  className,
  'data-testid': testId,
  name,
  optional,
  readOnly,
}: FormAddressProps) => {
  const { formatMessage } = useIntl();
  return (
    <Box
      sx={{
        '& .Mfw-Autocomplete-inputLabel__wrapper': {
          backgroundColor: 'background.paper',
        },
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
      className={className}
    >
      <AddressController name={name ? `${name}.country` : 'country'} />
      <FormCountry
        data-testid={testId ? `${testId}-country` : undefined}
        name={name ? `${name}.country` : 'country'}
        label={formatMessage(messages.country)}
        title={formatMessage(messages.country)}
        readOnly={readOnly}
      />
      <Box flexDirection={{ md: 'row', xs: 'column' }} display="flex" gap={2}>
        <FormTextField
          label={
            optional?.city
              ? formatMessage(messages.cityOptional)
              : formatMessage(messages.city)
          }
          data-testid={testId ? `${testId}-city` : undefined}
          name={name ? `${name}.city` : 'city'}
          readOnly={readOnly}
          className="w-full"
        />
        <FormTextField
          label={
            optional?.zip
              ? formatMessage(messages.zipOptional)
              : formatMessage(messages.zip)
          }
          data-testid={testId ? `${testId}-zip` : undefined}
          name={name ? `${name}.zip` : 'zip'}
          readOnly={readOnly}
          className="w-full"
        />
      </Box>
      <FormTextField
        label={
          optional?.street
            ? formatMessage(messages.streetOptional)
            : formatMessage(messages.street)
        }
        data-testid={testId ? `${testId}-street` : undefined}
        name={name ? `${name}.street` : 'street'}
        readOnly={readOnly}
      />
      {!readOnly && (
        <FormCheckboxField
          helperText={formatMessage(messages.isAddressPublicHelperText)}
          name={name ? `${name}.isAddressPublic` : 'isAddressPublic'}
          data-testid={testId ? `${testId}-public` : undefined}
          label={formatMessage(messages.isAddressPublic)}
        />
      )}
    </Box>
  );
};
